<template>
  <div class="billing-user-ranges">
    <div
      v-for="(range, index) in ranges"
      :key="index"
      class="range-item"
    >
      <div class="range-inputs">
        <div class="form-group">
          <label>Mínimo</label>
          <input
            v-model.number="range.min"
            type="number"
            min="1"
            class="form-control form-control-sm"
            @input="updateRanges"
          />
        </div>

        <div class="form-group">
          <label>Máximo</label>
          <input
            v-model.number="range.max"
            type="number"
            :min="range.min"
            class="form-control form-control-sm"
            @input="updateRanges"
          />
        </div>

        <div class="form-group flex-grow-1">
          <label>Valor (R$)</label>
          <input
            v-model.number="range.value"
            type="number"
            step="0.01"
            min="0"
            class="form-control form-control-sm"
            @input="updateRanges"
          />
        </div>

        <div class="form-group">
          <label>&nbsp;</label>
          <button
            type="button"
            class="btn btn-sm btn-danger"
            @click="removeRange(index)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      <div class="range-description">
        {{ getRangeDescription(range) }}
      </div>
    </div>

    <button
      type="button"
      class="btn btn-sm btn-secondary mt-2"
      @click="addRange"
    >
      <i class="fa fa-plus"></i> Adicionar Faixa
    </button>
  </div>
</template>

<script>
export default {
  name: 'BillingUserRanges',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      ranges: [],
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (Array.isArray(newValue) && newValue.length > 0) {
          this.ranges = [...newValue]
        } else if (!Array.isArray(newValue) || newValue.length === 0) {
          // Inicializa com uma faixa padrão apenas se não há valor
          this.ranges = [
            { min: 1, max: 10, value: 500 },
          ]
        }
      },
    },
  },

  methods: {
    addRange() {
      const lastRange = this.ranges[this.ranges.length - 1]
      const newMin = lastRange ? lastRange.max + 1 : 1

      this.ranges.push({
        min: newMin,
        max: newMin + 10,
        value: 0,
      })

      this.updateRanges()
    },

    removeRange(index) {
      if (this.ranges.length > 1) {
        this.ranges.splice(index, 1)
        this.updateRanges()
      }
    },

    updateRanges() {
      this.$emit('input', [...this.ranges])
    },

    getRangeDescription(range) {
      const maxText = range.max >= 999999 ? '+' : `- ${range.max}`
      const valueFormatted = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(range.value || 0)

      return `${range.min} ${maxText} usuários: ${valueFormatted}`
    },
  },
}
</script>

<style scoped>
.billing-user-ranges {
  padding: 15px;
  border-radius: 4px;
}

.range-item {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

.range-item:last-child {
  padding-bottom: 0;
  margin-bottom: 0;
  border-bottom: none;
}

.range-inputs {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  margin-bottom: 5px;
}

.range-inputs .form-group {
  margin-bottom: 0;
}

.range-inputs .form-group label {
  margin-bottom: 2px;
  font-size: 0.75rem;
  font-weight: 500;
}

.flex-grow-1 {
  flex-grow: 1;
}

.range-description {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6c757d;
}
</style>
